import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { UserContext } from '../common/UserContext';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ShubhamImage from '../../assest/images/Shubham1.png';
import DatePicker from 'react-datepicker';
import { format, max, parse } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import Select from 'react-select';
import CustomSingleValue from '../common/CustomSingleValue';

import config from "../../envconfig";


const ShipmentReportTable = () => {
  const [shipmentData, setShipmentData] = useState([]);
  const [selectedOption, setSelectedOption] = useState('1');
  const [pdfdata, setpdfdata] = useState([]);
  const [fromScp, setFromScp] = useState('');
  const [fromScpOptions, setFromScpOptions] = useState([]);
  const [productNames, setProductNames] = useState([]);
  const [selectedProductName, setSelectedProductName] = useState(null);
  const initialFromDate = new Date();
  initialFromDate.setMonth(initialFromDate.getMonth() - 1); // Set date one month ago
  const [startDate, setStartDate] = useState(format(initialFromDate, 'dd/MM/yyyy'));
  const [endDate, setEndDate] = useState(format(new Date(), 'dd/MM/yyyy'));

  const [toScp, setToScp] = useState('');
  const [scpOptions, setScpOptions] = useState([{ value: '', label: '--Select--' }]);
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType, CM_CompanyName } = useContext(UserContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageRange, setCurrentPageRange] = useState([1, 10]);
  const [ordersPerPage] = useState(5);
  const [isSelectOpen, setIsSelectOpen] = useState(null);
  const [searchOpt1, setSearchOpt1] = useState('');
  const [searchTxt1, setSearchTxt1] = useState('');
  const [searchOpt2, setSearchOpt2] = useState('');
  const [searchTxt2, setSearchTxt2] = useState('');

  const [isLoading,setIsLoadig] = useState(false)

  const formatDate = (dateString) => {
    return format(new Date(dateString), 'dd/MM/yyyy HH:mm:ss');
  };

  useEffect(() => {
    console.log("UM_UserType:", UM_UserType);
  }, [UM_UserType]);

  const handleFromScpChange = (selectedOption) => {
    setFromScp(selectedOption ? selectedOption.value : '');
  };

  useEffect(() => {
    fetch(`${config.API_URL}/productnames/${UM_CompanyID}`)
      .then(response => response.json())
      .then(data => {
        setProductNames(data.PL_ProductName);
      })
      .catch(error => console.error('Error fetching product names:', error));
  }, [selectedScpId]);

  const optionsproduct = [
    { value: null, label: 'All', code: '' },
    ...productNames.map(group => ({
      label: group.PL_ProductName,
      value: group.PL_ProductId,
      code: group.PL_ProductCode
    }))
  ];

  const handleChangeProductName = (selectedOption) => {
    setSelectedProductName(selectedOption ? selectedOption.label : null);
  };

  useEffect(() => {
    const fetchScpData = async () => {
      if (!selectedOption) return;

      try {
        console.log(`this is :- ${config.API_URL}/scpnamedatafor_toscp`);

        const response = await axios.get(`${config.API_URL}/scpnamedatafor_toscp`, {
          params: {
            UM_CompanyGrpID,
            UM_CompanyID,
            shipmentType: selectedOption,
            // Only send scpCode for Inward, and only if toScp is selected
            ...(selectedOption === '2' && toScp && toScp !== '' ? { scpCode: toScp } : {})
          }
        });

        if (response.data.success && response.data.data.length > 0) {
          const options = [
            { value: '', label: 'All', code: '' },
            ...response.data.data.map(item => ({
              value: item.SCPM_ID,
              label: item.SCPM_Name,
              code: item.SCPM_Code
            }))
          ];
          setScpOptions(options);
        } else {
          // No SCP found → clear dropdown properly
          setScpOptions([{ value: '', label: '--No SCP--', code: '' }]);
          setToScp('');      // Reset selected value
        }

      } catch (error) {
        console.error('Error fetching To SCP:', error);
        setScpOptions([{ value: '', label: 'ALL', code: '' }]);
      }
    };

    fetchScpData();
  }, [UM_CompanyGrpID, UM_CompanyID, selectedOption, ...(selectedOption === '2' ? [toScp] : [])]);

  useEffect(() => {
    if (Number(UM_UserType) !== 3) {
      fetch(`${config.API_URL}/scpnamedatafor_fromscp`)
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            const options = data.data.map(item => ({
              value: item.SCPM_ID,
              label: item.SCPM_Name,
              code: item.SCPM_Code
            }));
            setFromScpOptions(options);
          }
        })
        .catch(err => console.error("Error fetching From SCP:", err));
    }
  }, [UM_UserType]);

  const handleSaveClick = async () => {


    console.log('📋 Current state:', {
      selectedOption,
      toScp,
      fromScp,
      UM_UserType,
      selectedScpId,
      startDate: startDate,
      endDate: endDate,
    });

    if (!selectedOption) {
      toast.error('Shipment Type is required');
      return;
    }
    // Only block if toScp is undefined or null — but '' (ALL) is allowed
    if (!toScp && toScp !== '') {
      toast.error('Please select a To SCP.');
      return;
    }
    if (Number(UM_UserType) !== 3 && !fromScp) {
      toast.error('Please select a From SCP.');
      return;
    }

    setShipmentData([]);
    setpdfdata([]);

    // Pick fromScpId depending on user type
    const fromScpId = Number(UM_UserType) !== 3 ? fromScp : selectedScpId;

    // Endpoint depends on shipment type
    let endpoint;
    if (selectedOption === '1') {
      endpoint = `${config.API_URL}/api/outward/shipmentdata/${fromScpId}`;
    } else if (selectedOption === '2') {
      endpoint = `${config.API_URL}/api/inward/shipmentdata/${fromScpId}`;
    } else {
      toast.error('Invalid shipment type selected.');
      return;
    }

    // Ensure start & end are full-day ranges
    const adjustedStartDate = new Date(startDate);
    adjustedStartDate.setHours(0, 0, 0, 0);
    const adjustedEndDate = new Date(endDate);
    adjustedEndDate.setHours(23, 59, 59, 999);

    // Payload matches backend API
    const payload = {
      toScp: toScp, // already "ALL" or SCP ID as string
      startDate: startDate,
      endDate: endDate,
      status: 8, // default status
      productName: selectedProductName || 'All', // send empty string if null
    };

    try {
      const response = await axios.post(endpoint, payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.data.success) {
        setShipmentData(response.data.data);
        setpdfdata(response.data.data);

        if (response.data.data.length === 0) {
           toast.error('No shipment data found for the selected criteria.');
        }
      } else {
        toast.error('Failed to fetch shipment data.');
      }
    } catch (error) {
      console.error('❌ API request failed:', error);
      toast.error('Failed to fetch shipment data. Please try again.');
    }
  };

  const handleDropdownChange = (selectedOption) => {
    setShipmentData([]);
    setSearchOpt1('');
    setSearchTxt1('');
    setSearchOpt2('');
    setSearchTxt2('');
    // setStartDate(new Date(new Date().setMonth(new Date().getMonth() - 1)));
    // setEndDate(new Date());
    setToScp('');
    setSelectedOption(selectedOption ? selectedOption.value : '');
  };

  const handlepdf = async () => {
    const doc = new jsPDF('landscape');
    //const imgData = ShubhamImage;
    const logoRes = await fetch(`${config.API_URL}/logo-base64/${UM_CompanyGrpID}`);
    const logoJson = await logoRes.json();
    const imgData = logoJson.base64 || ShubhamImage;
    doc.addImage(imgData, 'PNG', 10, 10, 40, 20);

    const date = new Date();
    const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;

    const startX = doc.internal.pageSize.getWidth() - 50;
    let startY = 20;
    const colonOffset = 14.5;
    const valueOffset = 16.5;

    doc.setFontSize(8);
    doc.text("Printed On", startX, startY, { align: "left" });
    doc.text(":", startX + colonOffset, startY);
    doc.text(formattedDate, startX + valueOffset, startY);

    doc.text("Printed By", startX, startY + 5, { align: "left" });
    doc.text(":", startX + colonOffset, startY + 5);
    doc.text(UM_UserCode, startX + valueOffset, startY + 5);

    startY += 25;
    doc.setFontSize(21);
    doc.text("Shipment Report", doc.internal.pageSize.width / 2, startY, { align: 'center' });

    const headers = ['Sr. No.', 'Shipment Code', 'Order Number', 'Product Name', 'Product Code', 'Shipment Quantity', 'Logistic Party Name', 'Vehicle Number', 'Shipment Date'];

    const tableRows = filterData.map((item, index) => [
      index + 1,
      item.SHPH_ShipmentCode,
      item.ORDM_OrderNumber,
      item.SHPD_ProductName,
      item.SHPD_ProductCode,
      item.SHPD_ScanQty || '-',
      item.LogisticCompanyName,
      item.LogisticVehicleNumber,
      formatDate(item.SHPH_CreatedTimestamp),
    ]);

    const styles = {
      tableHeader: {
        fillColor: [41, 128, 185],
        textColor: [255, 255, 255],
        fontSize: 12,
        fontStyle: 'bold',
        valign: 'middle',
        halign: 'center',
        cellPadding: 2
      },
      tableRow: {
        fontSize: 10,
        textColor: [0, 0, 0],
        fillColor: [255, 255, 255],
        valign: 'middle',
        halign: 'center',
        cellPadding: 2
      }
    };

    doc.autoTable({
      head: [headers],
      body: tableRows,
      startY: startY + 10,
      theme: 'grid',
      headStyles: styles.tableHeader,
      styles: styles.tableRow,
      alternateRowStyles: { fillColor: [255, 255, 255] },
    });

    const tableY1 = doc.lastAutoTable.finalY + 10;
    const lastsign = [
      [
        { content: `` },
        { content: `Date` },
        { content: `Sign` },
      ],
      [
        { content: `Checked By :` },
        { content: `....................` },
        { content: `....................` },
      ],
      [
        { content: `  Verified By :` },
        { content: `....................` },
        { content: `....................` },
      ],
    ];

    doc.autoTable({
      head: [],
      body: lastsign,
      startY: tableY1,
      styles: {
        textColor: [0, 0, 0],
      },
      didDrawPage: () => {
        addFooter(doc);   // Footer applied to all pages
      }
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageHeight = doc.internal.pageSize.getHeight();
      const pageWidth = doc.internal.pageSize.getWidth();
      doc.setFontSize(8);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 20, pageHeight - 10, { align: 'right' });
    }

    addFooter(doc);
    doc.save('Shipment_Report.pdf');
  };

  const handleDownloadPdf = async () => {
    try {
      setIsLoadig(true);
      console.log("shipmenttype", selectedOption, "fromScp", fromScp, "toScp", toScp, "umusertype", UM_UserType, "selectedScpId", selectedScpId, "startDate", startDate, "endDate", endDate, "UM_UserCode", UM_UserCode, "UM_CompanyGrpID", UM_CompanyGrpID);
      const response = await fetch(`${config.API_URL}/Report/shipment-pdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          shipmentType: selectedOption,
          fromScpId: fromScp,
          toScp,
          UM_UserType,
          selectedScpId,
          startDate: startDate,
          endDate: endDate,
          UM_UserCode,
          UM_CompanyID,
          ShipmentType: shipmentTypeOptions.find(option => option.value === selectedOption)?.label || '',
          SCPName: scpOptions.find(option => option.value === toScp)?.label || '',
          productName: selectedProductName || '',
        }),
      });

      // ❌ handle 404 / 500 properly
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // ✅ get PDF blob
      const blob = await response.blob();

      // ✅ download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Shipment_Report.pdf';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('PDF downloaded successfully.',{onClose:()=> setIsLoadig(false)});

    } catch (error) {
      console.error('PDF download error:', error);
      toast.error('Failed to download PDF', { onClose: () => setIsLoadig(false) });
    }
  };

  const isValidDate = (date) => {
    const d = new Date(date);
    return d instanceof Date && !isNaN(d);
  };
  const handleKeyDown = (event) => {
    event.preventDefault();
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    const totalPageCount = Math.ceil(filterData.length / ordersPerPage);
    if (pageNumber > 5 && pageNumber + 5 <= totalPageCount) {
      setCurrentPageRange([pageNumber - 4, pageNumber + 5]);
    } else if (pageNumber <= 5) {
      setCurrentPageRange([1, Math.min(10, totalPageCount)]);
    } else {
      setCurrentPageRange([totalPageCount - 9, totalPageCount]);
    }
  };

  const addFooter = (doc) => {
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text(
        "Developed by : Shubham Automation Pvt. Ltd.",
        10,
        doc.internal.pageSize.getHeight() - 10
      );
    }
  };

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  const filterOptions = [
    { value: '', label: '--Select--' },
    { value: 'SCPName', label: 'SCP Name', isDisabled: searchOpt2 === 'SCPName' },
    { value: 'SHPH_ShipmentCode', label: 'Shipment Code', isDisabled: searchOpt2 === 'SHPH_ShipmentCode' },
    { value: 'ORDM_OrderNumber', label: 'Order Number', isDisabled: searchOpt2 === 'ORDM_OrderNumber' },
    { value: 'SHPD_ProductName', label: 'Product Name', isDisabled: searchOpt2 === 'SHPD_ProductName' },
    { value: 'SHPD_ProductCode', label: 'Product Code', isDisabled: searchOpt2 === 'SHPD_ProductCode' },
    { value: 'SHPD_ScanQty', label: 'Shipment Quantity', isDisabled: searchOpt2 === 'SHPD_ScanQty' },
    { value: 'LogisticCompanyName', label: 'Logistic Party Name', isDisabled: searchOpt2 === 'LogisticCompanyName' },
    { value: 'LogisticVehicleNumber', label: 'Vehicle Number', isDisabled: searchOpt2 === 'LogisticVehicleNumber' },
    { value: 'SHPH_CreatedTimestamp', label: 'Shipment Date', isDisabled: searchOpt2 === 'SHPH_CreatedTimestamp' },
  ];

  const filterOptions2 = [
    { value: '', label: '--Select--' },
    { value: 'SCPName', label: 'SCP Name', isDisabled: searchOpt1 === 'SCPName' },
    { value: 'SHPH_ShipmentCode', label: 'Shipment Code', isDisabled: searchOpt1 === 'SHPH_ShipmentCode' },
    { value: 'ORDM_OrderNumber', label: 'Order Number', isDisabled: searchOpt1 === 'ORDM_OrderNumber' },
    { value: 'SHPD_ProductName', label: 'Product Name', isDisabled: searchOpt1 === 'SHPD_ProductName' },
    { value: 'SHPD_ProductCode', label: 'Product Code', isDisabled: searchOpt1 === 'SHPD_ProductCode' },
    { value: 'SHPD_ScanQty', label: 'Shipment Quantity', isDisabled: searchOpt1 === 'SHPD_ScanQty' },
    { value: 'LogisticCompanyName', label: 'Logistic Party Name', isDisabled: searchOpt1 === 'LogisticCompanyName' },
    { value: 'LogisticVehicleNumber', label: 'Vehicle Number', isDisabled: searchOpt1 === 'LogisticVehicleNumber' },
    { value: 'SHPH_CreatedTimestamp', label: 'Shipment Date', isDisabled: searchOpt1 === 'SHPH_CreatedTimestamp' },
  ];

  const shipmentTypeOptions = [
    // { value: '', label: '--Select--' },
    { value: '1', label: 'Outward' },
    // { value: '2', label: 'Inward' },
  ];

  const handleOpt1 = (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : '';
    setSearchOpt1(newValue);
    if (newValue === 'SHPH_CreatedTimestamp') {
      setSearchTxt1(''); // Clear text input when date is selected
    } else if (!searchTxt1) {
      setSearchTxt1(''); // optional: keep empty if was cleared
    }
  };

  const handleOpt2 = (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : '';
    setSearchOpt2(newValue);
    if (newValue === 'SHPH_CreatedTimestamp') {
      setSearchTxt2(''); // Clear text input when date is selected
    }
  };

  const handleToScpChange = (selectedOption) => {
    setToScp(selectedOption ? selectedOption.value : '');
  };

  const handleTxt1 = (e) => {
    setSearchTxt1(e.target.value);
  };

  const handleTxt2 = (e) => {
    setSearchTxt2(e.target.value);
  };

  const filterData = shipmentData.filter(item => {
    // Parse the timestamp safely
    const itemDate = new Date(item.SHPH_CreatedTimestamp);

    // Normalize startDate and endDate to full-day range (UTC-safe)
    const normalizedStart = new Date(startDate);
    // normalizedStart.setHours(0, 0, 0, 0);

    const normalizedEnd = new Date(endDate);
    // normalizedEnd.setHours(23, 59, 59, 999);

    // Always apply date range filter from top date pickers
    const isWithinDateRange = itemDate >= normalizedStart && itemDate <= normalizedEnd;

    // If user selected "Shipment Date" in either search filter → enforce date range strictly
    const isDateFilterActive = searchOpt1 === 'SHPH_CreatedTimestamp' || searchOpt2 === 'SHPH_CreatedTimestamp';

    // Text-based filters
    let match1 = true;
    if (searchOpt1 && searchTxt1.trim() && searchOpt1 !== 'SHPH_CreatedTimestamp') {
      const value = item[searchOpt1];
      match1 = value != null && String(value).toLowerCase().includes(searchTxt1.toLowerCase());
    }

    let match2 = true;
    if (searchOpt2 && searchTxt2.trim() && searchOpt2 !== 'SHPH_CreatedTimestamp') {
      const value = item[searchOpt2];
      match2 = value != null && String(value).toLowerCase().includes(searchTxt2.toLowerCase());
    }

    // Final result: text filters + date range
    return (match1 && match2);
  });
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filterData.slice(indexOfFirstOrder, indexOfLastOrder);

  const totalPageCount = Math.ceil(filterData.length / ordersPerPage);
  useEffect(() => {
    if (totalPageCount < 10) {
      setCurrentPageRange([1, totalPageCount]);
    }
  }, [totalPageCount]);

  return (
    <>
      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />

      {isLoading && (
                <div style={{
                    position: 'fixed', // Sit on top of the page content
                    left: 0,
                    top: 0,
                    width: '100%', // Full width
                    height: '100%', // Full height

                    zIndex: 9999 // Sit on top of the other elements
                }} />
            )}

      <div className='main_container'>
        <h1 className='formHeading'>Shipment Report</h1>
        <div className="row">
          <div className='col-md-3'>
            <label>From</label>
            <DatePicker
              selected={startDate ? parse(startDate, 'dd/MM/yyyy', new Date()) : null}
              onChange={(date) => {
                if (isValidDate(date)) {
                  setStartDate(format(date, 'dd/MM/yyyy'));
                }
              }}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select From Date"
              className="form-control"
              onKeyDown={handleKeyDown}
            />

          </div>
          <div className='col-md-3'>
            <label>To</label>
            <DatePicker
              selected={endDate ? parse(endDate, 'dd/MM/yyyy', new Date()) : null}
              onChange={(date) => {
                if (isValidDate(date)) {
                  setEndDate(format(date, 'dd/MM/yyyy'));
                }
              }}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select To Date"
              className="form-control"
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className='col-md-3'>
            <label htmlFor="shipmentType">Shipment Type</label>
            <div className='select-container_list'>
              <Select
                options={shipmentTypeOptions}
                value={shipmentTypeOptions.find(option => option.value === selectedOption)}
                onChange={handleDropdownChange}
                name="SCPM_ScanningMode"
                onMenuOpen={() => handleSelectOpen('shipmentType')}
                onMenuClose={handleSelectClose}
                className="routing_select-box"
                classNamePrefix={"react-select"}
                maxMenuHeight={130}
                components={{ SingleValue: CustomSingleValue }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    cursor: 'pointer',
                    borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                    boxShadow: state.isFocused ? 'none' : base.boxShadow,
                    '&:hover': {
                      borderColor: '#cfcfcf',
                    },
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: -1,
                  }),
                }}
                isDisabled={true}
              />
              <div className='icon-container_list'>
                <i>
                  {isSelectOpen === 'shipmentType' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                </i>
              </div>
            </div>
          </div>
          {Number(UM_UserType) !== 3 && (
            <div className='col-md-3'>
              <label htmlFor="fromScp">From SCP</label>
              <div className='select-container_list'>
                <Select
                  options={fromScpOptions}
                  value={fromScpOptions.find(option => option.value === fromScp)}
                  onChange={handleFromScpChange}
                  name="fromScp"
                  onMenuOpen={() => handleSelectOpen('fromScp')}
                  onMenuClose={handleSelectClose}
                  className="routing_select-box"
                  maxMenuHeight={130}
                  components={{ SingleValue: CustomSingleValue }}
                  isDisabled={!selectedOption}
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                    option.data.code.toLowerCase().includes(inputValue.toLowerCase())
                  }
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      cursor: 'pointer',
                      borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                      boxShadow: state.isFocused ? 'none' : base.boxShadow,
                      '&:hover': {
                        borderColor: '#cfcfcf',
                      },
                    }),
                    menu: (base) => ({
                      ...base,
                      marginTop: -1,
                    }),
                  }}
                />
                <div className='icon-container_list'>
                  <i>
                    {isSelectOpen === 'fromScp' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                  </i>
                </div>
              </div>
            </div>
          )}
          <div className='col-md-3'>
            <label htmlFor="toScp">SCP Name</label>
            <div className='select-container_list'>
              <Select
                options={scpOptions}
                value={scpOptions.find(option => option.value === toScp)}
                onChange={handleToScpChange}
                name="toScp"
                onMenuOpen={() => handleSelectOpen('toScp')}
                onMenuClose={handleSelectClose}
                className="routing_select-box"
                maxMenuHeight={130}
                components={{ SingleValue: CustomSingleValue }}
                isDisabled={!selectedOption}
                filterOption={(option, inputValue) =>
                  option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                  (option.data.code && option.data.code.toLowerCase().includes(inputValue.toLowerCase()))
                }
              />
              <div className='icon-container_list'>
                <i>
                  {isSelectOpen === 'toScp' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                </i>
              </div>
            </div>
          </div>
          <div className='col-md-3 mt-2'>
            <label htmlFor="toScp">Product Name</label>
            <div className='select-container'>
              <Select
                id="productName"
                className='routing_select-box'
                value={optionsproduct.find(option => option.value === selectedProductName)}
                onChange={handleChangeProductName}
                options={optionsproduct}
                placeholder="--Select--"
                onMenuOpen={() => handleSelectOpen('Product')}
                onMenuClose={handleSelectClose}
                isDisabled={!selectedOption}
                components={{ SingleValue: CustomSingleValue }}
                styles={{
                  menuList: (base) => ({
                    ...base,
                    maxHeight: "150px",   // 👈 reduce dropdown height
                  }),

                }}
              />
              <div className='icon-container'>
                {isSelectOpen === 'Product' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
              </div>
            </div>
          </div>
          <div className='col-md-2 mt-2 searchPrintContainer'>
            <button className="search_btn col-md-8" onClick={handleSaveClick}>SEARCH</button>
            {shipmentData.length > 0 && (
              <button className='report_btn-OrderReport col-md-10'
                style={{ opacity: shipmentData.length === 0 ? 0.7 : 1, }}
                disabled={shipmentData.length === 0}
                onClick={handleDownloadPdf}>
                DOWNLOAD PDF
              </button>
            )}
          </div>
        </div>

        {/* <div className="row mt-2">
          <div className="col-md-3">
            <div className='select-container_list'>
              <Select
                options={filterOptions}
                value={filterOptions.find(option => option.value === searchOpt1)}
                onChange={handleOpt1}
                name="searchOpt1"
                onMenuOpen={() => handleSelectOpen('searchOpt1')}
                onMenuClose={handleSelectClose}
                className="routing_select-box"
                maxMenuHeight={130}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    cursor: 'pointer',
                    borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                    boxShadow: state.isFocused ? 'none' : base.boxShadow,
                    '&:hover': {
                      borderColor: '#cfcfcf',
                    },
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: -1,
                  }),
                }}
              />
              <div className='icon-container_list'>
                <i>
                  {isSelectOpen === 'searchOpt1' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                </i>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <input
              type='text'
              value={searchTxt1}
              onChange={handleTxt1}
              className='search-input searchbar'
              placeholder="Search"
            />
          </div>
          <div className="col-md-3">
            <div className='select-container_list'>
              <Select
                options={filterOptions2}
                value={filterOptions2.find(option => option.value === searchOpt2)}
                onChange={handleOpt2}
                name="searchOpt2"
                onMenuOpen={() => handleSelectOpen('searchOpt2')}
                onMenuClose={handleSelectClose}
                className="routing_select-box"
                maxMenuHeight={130}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    cursor: 'pointer',
                    borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                    boxShadow: state.isFocused ? 'none' : base.boxShadow,
                    '&:hover': {
                      borderColor: '#cfcfcf',
                    },
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: -1,
                  }),
                }}
              />
              <div className='icon-container_list'>
                <i>
                  {isSelectOpen === 'searchOpt2' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                </i>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <input
              type='text'
              value={searchTxt2}
              onChange={handleTxt2}
              className='search-input searchbar'
              placeholder="Search"
            />
          </div>
        </div> */}

        {(searchOpt1 === 'SHPH_CreatedTimestamp' || searchOpt2 === 'SHPH_CreatedTimestamp') && (
          <div className="row mt-3">
            <div className="col-md-3">
              <label>From Date</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  if (date > new Date()) {
                    toast.error("From Date cannot be in the future.");
                    return;
                  }
                  setStartDate(date);

                  if (date > endDate) {
                    setEndDate(date); // auto-correct To Date
                  }
                }}
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}   // ❗ prevents future dates
                className="routing_select-box"
                placeholderText="From Date"
              />

            </div>
            <div className="col-md-3">
              <label>To Date</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => {
                  if (date > new Date()) {
                    toast.error("To Date cannot be in the future.");
                    return;
                  }
                  if (date < startDate) {
                    toast.error("To Date cannot be earlier than From Date.");
                    return;
                  }
                  setEndDate(date);
                }}
                dateFormat="dd/MM/yyyy"
                minDate={startDate}    // ❗ cannot select earlier than FROM
                maxDate={new Date()}   // ❗ cannot select future
                className="routing_select-box"
              />

            </div>
          </div>
        )}

        <div className="ptable-wrapper">
          <table className="ptableClass mt-4">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>SCP Name</th>
                <th>Shipment Code</th>
                <th>Order Number</th>
                <th>Product Name</th>
                <th>Product Code</th>
                <th>Shipment Quantity</th>
                <th>Logistic Party Name</th>
                <th>Vehicle Number</th>
                <th>Created Date & Time</th>
              </tr>
            </thead>
            {filterData.length === 0 ? (
              <tr>
                <td colSpan="10">No Records Found</td>
              </tr>
            ) : (
              <tbody>
                {currentOrders.map((item, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * ordersPerPage + index + 1}</td>
                    <td>{item.SCPName}</td>
                    <td>{item.SHPH_ShipmentCode}</td>
                    <td>{item.ORDM_OrderNumber}</td>
                    <td>{item.SHPD_ProductName}</td>
                    <td>{item.SHPD_ProductCode}</td>
                    <td>{item.SHPD_ScanQty || '-'}</td>
                    <td>{item.LogisticCompanyName}</td>
                    <td>{item.LogisticVehicleNumber}</td>
                    <td>{formatDate(item.SHPH_CreatedTimestamp)}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>

      <ul className="pagination">
        <li className={currentPage === 1 || totalPageCount === 0 ? "page-item disabled" : "page-item"}>
          <button className="page-linkd" onClick={() => paginate(1)} disabled={currentPage === 1 || totalPageCount === 0}>First</button>
        </li>
        <li className={currentPage === 1 || totalPageCount === 0 ? "page-item disabled" : "page-item"}>
          <button className="page-linkd" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1 || totalPageCount === 0}>Previous</button>
        </li>
        {totalPageCount > 0 && Array.from({ length: totalPageCount }).map((_, index) => {
          const pageNumber = index + 1;
          if (pageNumber >= currentPageRange[0] && pageNumber <= currentPageRange[1]) {
            return (
              <li key={index} className={currentPage === pageNumber ? "page-item active" : "page-item"}>
                <button className="page-linkd" onClick={() => paginate(pageNumber)}>{pageNumber}</button>
              </li>
            );
          }
          return null;
        })}
        <li className={currentPage === totalPageCount || totalPageCount === 0 ? "page-item disabled" : "page-item"}>
          <button className="page-linkd" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPageCount || totalPageCount === 0}>Next</button>
        </li>
        <li className={currentPage === totalPageCount || totalPageCount === 0 ? "page-item disabled" : "page-item"}>
          <button className="page-linkd" onClick={() => paginate(totalPageCount)} disabled={currentPage === totalPageCount || totalPageCount === 0}>Last</button>
        </li>
      </ul>
    </>
  );
};

export default ShipmentReportTable;

